import React from 'react'
import { Link, graphql } from 'gatsby'
import styled from "styled-components"

import Layout from '../components/Layout'
import SEO from '../components/seo'

const Intro = styled.div`
    color: #333;
    font-size: 1.8rem;
    line-height: 1.3;
    margin-bottom: 6rem;
    padding-right: 4rem;

    @media only screen and (max-width: 768px) {
      margin-bottom: 3rem;
    }
`

const Headline = styled.h1`
    font-size: 5rem;
    margin-bottom: 1rem;
    font-weight: 600;

    @media only screen and (max-width: 768px) {
      margin-top: 1rem;
      font-size: 3rem;
      line-height: 1;
    }
`

const Listing = styled.div`
  padding: 2rem 4rem 2rem 2rem;
  margin-bottom: 1rem;
  background-color: #eee;
  color: 333;

  &:hover {
    background-color: #0D5C00;
    color: #fff;
    transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
  }
`

const StyledLink = styled(Link)`
  color: #333;
  font-size: 2.6rem;
  font-weight: 500;
  text-decoration: none;

  &:hover {
    color: #fff;
  }
`;

const Summary = styled.p`
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 1.4;
  margin-top: .5rem;
`

const IntroP = styled.p`
  font-size: 1.8rem;
  line-height: 1.4;
  margin-top: 1rem;
`

const Anchor = styled.a`
  color: #0D5C00;
  font-weight: 600;
  text-decoration: none;
`

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.chapter
    const posts = data.allMarkdownRemark.edges

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="Fresh Market Project"
          keywords={[`product design`, `designer`, `UX`, `user experience`]}
        />

        <Intro>
            <Headline>Project: Fresh Market</Headline>
            <IntroP>This project allows designers to encounter each step of the design process. In doing so, designers will gain a better understanding of how good UX can elevate our Interface solutions.</IntroP> 

            <IntroP>At multiple points on this journey, students will interact with real users to understand how they use products and services. These conversations will help shape the direction individual  projects will take.</IntroP>
              
            <IntroP>This is a self-paced project and involves at least 100 hours of work to complete. The number of weeks that takes will depend on the amount of time you can commit each day.</IntroP>
              
            <IntroP>Designers who have completed the <Anchor href="/ux">User Experience</Anchor> and <Anchor href="/interface">Interface Design</Anchor> curriculum will move faster as the project builds on top of previously acquired knowledge.</IntroP>

        </Intro>

        {posts.map(({ node }) => {
          const chapter = node.frontmatter.chapter || node.fields.slug
          const sub = node.frontmatter.sub


          return (
            <StyledLink to={node.fields.slug}>
              <Listing key={node.fields.slug}>
                <h3>
                    {chapter}
                </h3>
                <Summary dangerouslySetInnerHTML={{ __html: sub }} />
              </Listing>
            </StyledLink>

          )
        })}
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___courseOrder], order: ASC }
      filter: { frontmatter: { tags: { eq: "project-market" } }
    }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            chapter
            title
            sub
          }
        }
      }
    }
  }
`
